import { useContext } from "react";
import LanguageContext from "../providers/LanguageProvider";
const useTranslation = () => {
    const languageCtx = useContext(LanguageContext);
    return {
        changeLanguage: languageCtx.updateLanguage,
        translate: languageCtx.translate,
        language: languageCtx.language.abbreviations,
        direction: languageCtx.language.direction
    };
};
export default useTranslation;
